import React, {useRef, useState} from 'react';
import {Alert, Button, Form} from 'react-bootstrap';
import {respondToReconciliation} from '../../../../services/ReconciliationActionService';

const small={fontSize:'0.8125rem'};

/** A question from Mats about one bank line, answered in free text. Sized for the bank sheet and the Att göra rows. */
export default function ReconciliationQuestion({companyId,workId,question,onAnswered}) {
    const [answer,setAnswer]=useState(''),[busy,setBusy]=useState(false),[error,setError]=useState(''),[sent,setSent]=useState(false);
    const delivery=useRef(null);
    const submit=async event=>{
        event.preventDefault();if(!answer.trim()||busy)return;
        setBusy(true);setError('');
        if(!delivery.current || delivery.current.answer!==answer) delivery.current={responseId:crypto.randomUUID(),answer};
        try {
            await respondToReconciliation(companyId,workId,{questionId:question.questionId,bankGeneration:question.bankGeneration,
                answerVersion:question.answerVersion,...delivery.current});
            setSent(true);onAnswered?.();
        } catch(e) {setError(e.response?.status===409?'Frågan har ändrats eller är redan hanterad. Uppdatera ärendet.':'Svaret kunde inte skickas. Försök igen.');}
        finally {setBusy(false);}
    };
    if(sent)return <div role="status" style={{...small,color:'#374151',marginTop:8}}>Svaret är sparat. Mats fortsätter när ärendet kan köras.</div>;
    return <Form onSubmit={submit} style={{marginTop:8}}>
        <Form.Label htmlFor={`answer-${question.questionId}`} style={{...small,fontWeight:500,color:'#111827',marginBottom:4}}>{question.prompt}</Form.Label>
        <Form.Control as="textarea" rows={2} size="sm" id={`answer-${question.questionId}`} value={answer} maxLength={8000} onChange={e=>setAnswer(e.target.value)} disabled={busy} style={small}/>
        {error && <Alert variant="warning" className="mt-2 mb-0 py-2" style={small}>{error}</Alert>}
        <div className="d-flex align-items-center flex-wrap" style={{gap:10,marginTop:8}}>
            <Button type="submit" size="sm" disabled={busy||!answer.trim()}>{busy?'Sparar…':'Skicka svar'}</Button>
            <span style={{fontSize:'0.75rem',color:'#6b7280'}}>Svaret kompletterar underlaget. Det är inget godkännande att bokföra.</span>
        </div>
    </Form>;
}
